import Vue from "vue";
import "@/components/element-variables.scss";
import {
  Button,
  Select,
  Dialog,
  Input,
  Option,
  MessageBox,
  Message,
  Notification,
  Loading,
  Image,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Autocomplete,
  Popover,
  Checkbox,
} from "element-ui";
Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(Dialog.name, Dialog);
Vue.component(Input.name, Input);
Vue.component(Option.name, Option);
Vue.component(Image.name, Image);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(Autocomplete.name, Autocomplete);
Vue.component(Popover.name, Popover);
Vue.component(Checkbox.name, Checkbox);


Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$notify = Notification;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;

// tip：注册组件后还需要在components/element-variables.scss中引入组件样式
